import { render, staticRenderFns } from "./ListEmpty.vue?vue&type=template&id=19bfa000&scoped=true&"
import script from "./ListEmpty.vue?vue&type=script&lang=js&"
export * from "./ListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ListEmpty.vue?vue&type=style&index=0&id=19bfa000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfa000",
  null
  
)

export default component.exports